module.exports = __webpack_public_path__ + "img/Coloca_Pega Azulejos.e6601209.png";